export var RefStack = function RefStack() {
  var _this = this;

  this.set = new Set();

  this.getContextRefs = function (ref) {
    var nodes = Array.from(_this.set);
    var refId = nodes.indexOf(ref);
    return nodes.slice(refId);
  };

  this.register = function (ref) {
    _this.set.add(ref);
  };

  this.unregister = function (ref) {
    _this.set.delete(ref);
  };
};